type Listener = () => void;

const listeners = new Set<Listener>();

/**
 * Lets distant components (e.g. the screener empty-state CTA) open the main
 * filter menu without reaching into the DOM for the trigger button. The
 * menu's popover subscribes while mounted; requests made while no menu is on
 * the page are dropped.
 */
export function onFilterMenuOpenRequest(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function requestFilterMenuOpen() {
  for (const listener of listeners) {
    listener();
  }
}
